import { useTranslation } from "next-i18next";

import { Heading } from "@/ui/cva/Heading";

/**
 * The homepage's one semantic H1 (WHO-5757), in a slim band. It states
 * the same proposition as the localised `<title>`, so search engines read the
 * page topic in every locale. Trust USPs already sit in the header bar, so the
 * band carries the H1 only. The hero below is a visual banner and renders an H2.
 */
export const HomepageIntroBlock = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-brand-500 px-4 py-1.5 md:px-6 md:py-2 lg:px-12 xl:px-24">
      <Heading
        as="h1"
        size="h5"
        className="text-xs leading-4 text-white md:text-base md:leading-6"
      >
        {t("homepage:homepage-intro-h1-v2")}
      </Heading>
    </section>
  );
};
